import React, { Component } from 'react'

import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter,  MDBBreadcrumb, MDBBreadcrumbItem, MDBAlert } from 'mdbreact';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavbarToggler, MDBCollapse, MDBNavItem, MDBNavLink, MDBMask, MDBView, MDBJumbotron, MDBBox } from 'mdbreact';
import { MDBTable, MDBTableBody, MDBTableHead,  } from 'mdbreact';
import { Form, Input, Button, Checkbox, message } from 'antd';
//import Login from './Login';
import Axios from 'axios'
import { URL } from '../../api';
import logo from '../img/logokpru.png'
import FadeIn from 'react-fade-in';
import p1 from '../img/1656587759_2-illustration_png.png'
import p2 from '../img/1656587759_4-illustration_png.png'
import p3 from '../img/1656587761_12-illustration_png.png'
import p4 from '../img/1656587766_35-illustration_png.png'
import Iframe from 'react-iframe'
import {isMobile, browserName, osName, OsTypes } from 'react-device-detect';

import { HorizontalBar } from 'react-chartjs-2';


import Swal from 'sweetalert2'
import {
  MDBTypography,
  MDBCard,
  MDBCardBody,
  MDBCardImage,
  MDBCardTitle,
  MDBCardText
} from 'mdbreact';

var xlsx = require("xlsx");


export default class Retire extends Component {


  constructor(props) {
    super(props);
    this.state = {
      value: '',
      Psaaword: '',
      modal: false,
      collapse: false,
      isWideEnough: false,
      datastuKamphaengphet:[],
      team: '2565',

      device:'',
      osName:'',
      browsername:'',
      datelogin:'',
      timelogin:'',
      sizem:'',
      dataretire:[],
      yearshow:'',

      years:'',
      yearf:'',
      yearss:'',

      years2:'',
      yearf2:'',

      yearfnew:'',
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChange2 = this.handleChange2.bind(this);
    this.toggle = this.toggle.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onClick2 = this.onClick2.bind(this);
    this.readUploadFile = this.readUploadFile.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
    this.emp = this.emp.bind(this);
     this.handleChangetype = this.handleChangetype.bind(this);
  }

  refreshPage() {
    window.location.reload(false);
  }

   handleChangetype(event) {   
   // console.log(event);  

   const yearll = event.target.value-60;

   const sdfd = Number(event.target.value)+543;
      
      this.setState({yearfnew: sdfd});  

   const yys =  yearll+'-09-30';
   const yyf =  yearll - 1;
   const yyf1 =  yyf+'-10-01';

   console.log(yys); 
   console.log(yyf1); 

   this.setState({years: yys});  
   this.setState({yearf: yyf1});  

   const yearll2 = yearll+543;
   const yyf2 =  yearll2 - 1;

   
  
  const yys2 =  '30-09-'+yearll2;
  const yyf12 =  '01-10-'+yyf2;
    this.setState({yearss: yearll2});  

    this.setState({years2: yys2});  
    this.setState({yearf2: yyf12});  

    this.setState({yearshow: event.target.value});  


    }
  

  componentDidMount() {
    if (isMobile) {
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD');
      const formattedtime =moment(now).format('HH:mm');
      // return <div> This content is available only on mobile</div>
      console.log('mobile')
      console.log(browserName)
      console.log(osName)
      console.log(formattedDate)

    
     this.setState({
      device: 'mobile',
      sizem:'250',
      browsername: browserName,
      datelogin : formattedDate,
      timelogin : formattedtime,
      osName : osName,
    });

    }else{
  
      console.log('browser')
      console.log(browserName)
      console.log(osName)
      const moment = require('moment');
      const  now = new Date();
      const formattedDate =moment(now).format('YYYY-MM-DD HH:mm:ss');
      const formattedtime =moment(now).format('HH:mm');

      const formattedDates =moment(now).format('YYYY');
      console.log(formattedDates)
const sdfd = Number(formattedDates)+543;
      
      this.setState({yearfnew: sdfd});  

const formattedDatesl=formattedDates-60;

      const yys =  formattedDatesl+'-09-30';
      const yyf =  formattedDatesl - 1;
      const yyf1 =  yyf+'-10-01';

      this.setState({years: yys});  
      this.setState({yearf: yyf1});  
   
      console.log(yys); 
      console.log(yyf1); 


      const yearll2 = formattedDatesl+543;
      const yyf2 =  yearll2 - 1;
      const yys2 =  '30-09-'+yearll2;
      const yyf12 =  '01-10-'+yyf2;
         this.setState({yearss: yearll2});  
     
         this.setState({years2: yys2});  
         this.setState({yearf2: yyf12});  





      console.log(formattedDate)

      this.setState({
        device: 'browser',
        sizem:'800',
        browsername: browserName,
        datelogin : formattedDate,
        timelogin : formattedtime,
        osName : osName,
      });



        Axios.get('https://mua.kpru.ac.th/FrontEnd_Info/index/selectemp60year/'+yyf1+'/'+yys)
      .then((res) => {
        
        //  console.log(res.data)
          this.setState({ dataretire: res.data })
      })
      .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
       
    }
      // this.emp();
    

  }

  emp(){


    Axios.get('https://mua.kpru.ac.th/FrontEnd_Info/index/selectemp60year/'+this.state.yearf+'/'+this.state.years)
    .then((res) => {
      
      //  console.log(res.data)
        this.setState({ dataretire: res.data })
    })
    .catch((err) => { alert("ไม่สำเร็จ " + err) }) // เมื่อเกิด error จะมาทำที่คำสั่งนี้แทน
  }

 onClick2() {
     console.log('dd')
          Axios.get('https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json')
         .then((res) => {
      //  console.log(res.data)
        this.setState({ datastuKamphaengphet: res })
    })

  }


  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }


  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  }

  handleChange(event) { this.setState({ value: event.target.value }); }
  handleChange2(event) { this.setState({ Psaaword: event.target.value }); }




  update = () => {
    this.setState({
      name: "",
      lname: ""
    })
  }

  readUploadFile = (e) => {
    e.preventDefault();
    if (e.target.files) {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = xlsx.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = xlsx.utils.sheet_to_json(worksheet);
         //   console.log(json);
            this.setState({ datastuKamphaengphet: json })

        };
        reader.readAsArrayBuffer(e.target.files[0]);
    }
}


  render() {
    const dUrl = "https://portal.bopp-obec.info/obec64/restpublicstat/download/area/2564-2-schoolmis-00620001.json";

    console.log(this.state.yearshow)

  // console.log(dUrl);
  // console.log(this.state.datastuKamphaengphet)
 //console.log('dd')
    const dataHorizontal = {
      labels: ['Red', 'Orange', 'Yellow', 'Green', 'Blue', 'Purple', 'Grey'],
      datasets: [
        {
          label: 'My First Dataset',
          data: [22, 33, 55, 12, 86, 23, 14],
          fill: false,
          backgroundColor: [
            'rgba(255, 99, 132, 0.2)',
            'rgba(255, 159, 64, 0.2)',
            'rgba(255, 205, 86, 0.2)',
            'rgba(75, 192, 192, 0.2)',
            'rgba(54, 162, 235, 0.2)',
            'rgba(153, 102, 255, 0.2)',
            'rgba(201, 203, 207, 0.2)'
          ],
          borderColor: [
            'rgb(255, 99, 132)',
            'rgb(255, 159, 64)',
            'rgb(255, 205, 86)',
            'rgb(75, 192, 192)',
            'rgb(54, 162, 235)',
            'rgb(153, 102, 255)',
            'rgb(201, 203, 207)'
          ],
          borderWidth: 1
        }
      ]
    }
    const sss = this.state.sizem


    return (

      <>
       
       <MDBRow >
          <MDBCol md="12">
            <div>
              {/* <img src="https://research.kpru.ac.th/culture/LogoRDI.png" className="rounded mx-auto d-block w-50" alt="aligment" /><br/> */}
              {/* <img src={logo} className="rounded mx-auto d-block w-10 " alt="aligment" /><br/> */}
              <FadeIn>
              <MDBJumbotron className="p-4" fluid >
                 
                <MDBTypography blockquote bqColor='primary' className='h-0'>
                  <MDBIcon icon="user-injured" />  ระบบบุคลากร
                </MDBTypography>
                    {/* <MDBTypography note noteColor='primary' noteTitle='ด้านนักศึกษา '> </MDBTypography> */}
                    <MDBBreadcrumb>
                        <MDBBreadcrumbItem>ระบบสารสนเทศเพื่อการตัดสินใจด้านการบริหาร</MDBBreadcrumbItem>
                        <MDBBreadcrumbItem active>บุคลากรเกษียณอายุราชการ</MDBBreadcrumbItem>
                    </MDBBreadcrumb>
                    <div className='text-right'> <a href='/welcome'><MDBBtn  color="blue-grey" size='sm'><MDBIcon icon="caret-left" /> กลับหน้าหลัก</MDBBtn></a><MDBBtn  color="mdb-color" size='sm' onClick={this.refreshPage}><MDBIcon icon="redo" /> refresh</MDBBtn></div>
                       <h3 className='text-center'><strong>ผู้เกษียนอายุราชการ </strong></h3> 


                         <div className="mb-2 mt-2">
                            <label><strong>ปีงบประมาณ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype} width="50%">
                                        <option>------เลือกปีงบประมาณ------</option>
                                         <option value="2025" >2568</option>
                                         <option value="2026" >2569</option>
                                         <option value="2027" >2570</option>
                                         <option value="2028" >2571</option>
                                         <option value="2029" >2572</option>
                                         <option value="2030" >2573</option>
                                         <option value="2031" >2574</option>
                                         <option value="2032" >2575</option>
                                         <option value="2033" >2576</option>
                                         <option value="2034" >2577</option>
                                         <option value="2035" >2578</option>
                                         <option value="2036" >2579</option>
                                         <option value="2037" >2580</option>
                                         <option value="2038" >2581</option>
                                         <option value="2039" >2582</option>
                                         <option value="2040" >2583</option>
                                         <option value="2041" >2584</option>
                                         <option value="2042" >2585</option>
                                         <option value="2043" >2586</option>
                                         <option value="2044" >2587</option>
                                         <option value="2045" >2588</option>
                                         <option value="2046" >2589</option>
                                         <option value="2047" >2590</option>
                                         <option value="2048" >2591</option>
                                         <option value="2049" >2592</option>
                                         <option value="2050" >2593</option>
                                         <option value="2051" >2594</option>
                                         <option value="2052" >2595</option>
                            </select>
                            </div>
                            <div className='text-center'>
                                <MDBBtn color="primary" onClick={this.emp} >ค้นหา</MDBBtn>
                            </div>
                           
                      <p>จำนวนผู้เกษียนอายุราชการปีงบประมาณ {this.state.yearfnew} จำนวน {this.state.dataretire.length} ท่าน | ช่วงวันเกิด {this.state.yearf2} ถึง {this.state.years2}</p>  
                         <MDBTable small style={{ border: "1px" }} border width="100%" >
                                                   <MDBTableHead   color=" grey grey lighten-2">
                                                       <tr  >
                                                           <th>ลำดับ</th>
                                                           <th>ชื่อ-นามสกุล</th>
                                                           <th>สังกัด</th>
                                                           <th className='text-center'>รูปประจำตัว</th>
                                                       </tr>
                                                   </MDBTableHead>
                       
                       
                                                   <MDBTableBody>
                                                       {this.state.dataretire.map((data,index) => {
                                                     //   const im = "https://mis.kpru.ac.th/images/pic_emp_50/".{data.employee_id}.".jpg";
                                                           return <tr>
                                                               <td>{index+1} </td>
                                                               
                                                               <td>{data.prename_full_tha}{data.first_name_tha} {data.last_name_tha}</td>
                                                               <td>{data.organization_name_tha	}</td>
                                                               <td > <div className='text-center'><img src={`https://mis.kpru.ac.th/images/pic_emp_50/`+data.employee_id+`.jpg`} className="rounded float-center " alt="aligment"  width="10%"  /></div></td>
                                                           </tr>
                                                       })}
                                                   </MDBTableBody>
                                               </MDBTable>

                            {/* <br/> */}
                            {/* <p>ระบบโหลดข้อมูลจำนวนมาก กรุณารอสักครู่</p> */}
                            {/* <iframe src="https://datastudio.google.com/embed/reporting/c100fb1c-4c88-41ea-b941-b9c2e83a3935/page/Cds4C" frameborder="0" style="overflow:hidden;height:100%;width:100%" height="100%" width="100%"></iframe> */}
                            {/* <MDBAlert color="warning" >
                            <p className='text-center'>อยู่ระหว่างดำเนินการ</p>
                            </MDBAlert> */}
                            {/* <Iframe url="https://lookerstudio.google.com/embed/reporting/eafd3c30-0f27-43e4-9e3b-9d880c2ae804/page/pYDoD"
                                 width="100%"
                                 height={sss}
                                 id=""
                                 className=""
                                 display="block"
                                 position="relative"/> */}

              </MDBJumbotron>

              </FadeIn>
            </div>
          </MDBCol>
        </MDBRow>

      </>


    )
  }
}
